import { ComponentSingleStyleConfig } from '@chakra-ui/theme';

// Divider styles
const Divider: ComponentSingleStyleConfig = {
  baseStyle: {
    borderWidth: '1px',
    color: 'border.secondary',
    opacity: 1,
  },
};

export default Divider;
